/**
 * GoNOW API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 2020-12-7
 * Contact: info@zero-spec.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
* The TankTypeResponse model module.
* @module model/TankTypeResponse
* @version 2020-12-7
*/
export default class TankTypeResponse {
    /**
    * Constructs a new <code>TankTypeResponse</code>.
    * タンクタイプ
    * @alias module:model/TankTypeResponse
    * @class
    * @param id {Number} タンクID
    * @param tankTypeCode {String} タンクタイプコード
    * @param tankName {String} タンク名
    * @param makerName {String} メーカー名
    * @param oilMaxVolume {Number} 最大容量
    * @param tankMaxVolume {Number} 法定容量
    * @param oilVolumeRate {Number} オイル係数
    * @param tankSize {Array.<Number>} タンクサイズ（w, d, h）
    * @param updatedAt {Number} 最終更新時刻(epoch秒)
    */

    constructor(id, tankTypeCode, tankName, makerName, oilMaxVolume, tankMaxVolume, oilVolumeRate, tankSize, updatedAt) {
        
        
        this['id'] = id;
        this['tankTypeCode'] = tankTypeCode;
        this['tankName'] = tankName;
        this['makerName'] = makerName;
        this['oilMaxVolume'] = oilMaxVolume;
        this['tankMaxVolume'] = tankMaxVolume;
        this['oilVolumeRate'] = oilVolumeRate;
        this['tankSize'] = tankSize;
        this['updatedAt'] = updatedAt;
        
    }

    /**
    * Constructs a <code>TankTypeResponse</code> from a plain JavaScript object, optionally creating a new instance.
    * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
    * @param {Object} data The plain JavaScript object bearing properties of interest.
    * @param {module:model/TankTypeResponse} obj Optional instance to populate.
    * @return {module:model/TankTypeResponse} The populated <code>TankTypeResponse</code> instance.
    */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new TankTypeResponse();
                        
            
            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'Number');
            }
            if (data.hasOwnProperty('tankTypeCode')) {
                obj['tankTypeCode'] = ApiClient.convertToType(data['tankTypeCode'], 'String');
            }
            if (data.hasOwnProperty('tankName')) {
                obj['tankName'] = ApiClient.convertToType(data['tankName'], 'String');
            }
            if (data.hasOwnProperty('makerName')) {
                obj['makerName'] = ApiClient.convertToType(data['makerName'], 'String');
            }
            if (data.hasOwnProperty('oilMaxVolume')) {
                obj['oilMaxVolume'] = ApiClient.convertToType(data['oilMaxVolume'], 'Number');
            }
            if (data.hasOwnProperty('tankMaxVolume')) {
                obj['tankMaxVolume'] = ApiClient.convertToType(data['tankMaxVolume'], 'Number');
            }
            if (data.hasOwnProperty('oilVolumeRate')) {
                obj['oilVolumeRate'] = ApiClient.convertToType(data['oilVolumeRate'], 'Number');
            }
            if (data.hasOwnProperty('tankSize')) {
                obj['tankSize'] = ApiClient.convertToType(data['tankSize'], ['Number']);
            }
            if (data.hasOwnProperty('remarks')) {
                obj['remarks'] = ApiClient.convertToType(data['remarks'], 'String');
            }
            if (data.hasOwnProperty('updatedAt')) {
                obj['updatedAt'] = ApiClient.convertToType(data['updatedAt'], 'Number');
            }
        }
        return obj;
    }

    /**
    * タンクID
    * @member {Number} id
    */
    'id' = undefined;
    /**
    * タンクタイプコード
    * @member {String} tankTypeCode
    */
    'tankTypeCode' = undefined;
    /**
    * タンク名
    * @member {String} tankName
    */
    'tankName' = undefined;
    /**
    * メーカー名
    * @member {String} makerName
    */
    'makerName' = undefined;
    /**
    * 最大容量
    * @member {Number} oilMaxVolume
    */
    'oilMaxVolume' = undefined;
    /**
    * 法定容量
    * @member {Number} tankMaxVolume
    */
    'tankMaxVolume' = undefined;
    /**
    * オイル係数
    * @member {Number} oilVolumeRate
    */
    'oilVolumeRate' = undefined;
    /**
    * タンクサイズ（w, d, h）
    * @member {Array.<Number>} tankSize
    */
    'tankSize' = undefined;
    /**
    * 備考
    * @member {String} remarks
    */
    'remarks' = undefined;
    /**
    * 最終更新時刻(epoch秒)
    * @member {Number} updatedAt
    */
    'updatedAt' = undefined;




}
